import styled from 'styled-components'
import { theme } from 'utils/theme'

export const ModalContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalDialog = styled.div`
  max-width: 500px;
  background: #f5f5f5;
  padding: 50px;
  border-radius: 10px;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.5));
`
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: ${theme.colors.white};
  gap: 20px;
`
